<template>
  <v-dialog
    v-if="show"
    v-model="dialog"
    light
    scrollable
    transition="slide-y-transition"
  >
    <template #activator="{ on, attrs }">
      <v-badge
        dot
        color="primary"
        offset-x="44"
        offset-y="14"
        :value="badge"
      >
        <v-btn
          v-on="on"
          v-bind="attrs"
          icon
          :disabled="loading"
        >
          <v-icon v-text="icons[icon ?? filter]" />
        </v-btn>
      </v-badge>
    </template>
    <v-card>
      <v-toolbar
        flat
        dense
        color="grey lighten-4"
      >
        <v-icon left v-text="icons[icon ?? filter]" />
        <v-toolbar-title v-text="__(title ?? filter)" class="text-h6" />
        <v-spacer />
        <v-btn
          icon
          color="primary"
          @click="dialog = false"
        >
          <v-icon v-text="icons.close" />
        </v-btn>
      </v-toolbar>
      <v-divider />
      <v-card-text class="pa-0">
        <v-list dense>
          <v-list-item-group
            v-model="selected"
            color="primary"
          >
            <template v-for="(item, i) in items">
              <v-subheader
                v-if="item.subheader"
                v-text="item.subheader"
                :key="`h${i}`"
              />
              <v-list-item
                v-else
                :key="`i${i}`"
              >
                <v-list-item-title v-text="item.name ?? item.value" />
              </v-list-item>
            </template>
          </v-list-item-group>
        </v-list>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapState } from 'vuex'
  import I18n from '@/Mixins/I18n'
  import UsesIcons from '@/Mixins/UsesIcons'

  export default {
    mixins: [
      I18n,
      UsesIcons,
    ],

    props: {
      filter: {
        required: true,
        type: String,
      },
      icon: {
        type: String,
      },
      title: {
        type: String,
      },
    },

    data: () => ({
      dialog: false,
    }),

    computed: {
      ...mapState('history', [
        'loading',
        'filters',
      ]),
      show () {
        return this.items.length > 1
      },
      items () {
        return this.$store.getters['history/filterItems'](this.filter)
      },
      badge () {
        return !! this.filters[this.filter]?.value
      },
      selected: {
        get () {
          return this.filters[this.filter]?.selected
        },
        set (v) {
          this.$store.commit('history/filter', {
            key: this.filter,
            selected: v,
            value: v !== undefined
              ? this.items.filter(o => o.hasOwnProperty('value'))[v]?.value
              : null,
          })
          this.dialog = false
        },
      },
    },
  }
</script>
